export default __webpack_public_path__ + "static/media/International_Pokémon_logo.svg.6a6dbe62.png";